<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span fxFlex>Select Contact to edit</span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color cursor-pointer"
			>close</mat-icon
		>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<div fxFlex fxLayoutAlign="center center">
		<mat-form-field *ngIf="!utilService.isNullOrUndefined(data.contactList)" fxFlex>
			<mat-label>Select contact</mat-label>
			<mat-select [(ngModel)]="selectedCarrier">
				<mat-option *ngFor="let contact of data.contactList" [value]="contact">
					<span fxFlex> {{contact.firstName || ''}} {{contact.lastName || ''}} </span>
					<span fxFlex> {{contact.email}} </span>
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end end" fxLayoutGap="1rem">
		<button
			(click)="closeDialog(selectedCarrier)"
			[disabled]="utilService.isNullOrUndefined(selectedCarrier)"
			color="primary"
			mat-raised-button
		>
			Next
		</button>
	</div>
</mat-dialog-actions>
